'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inject = inject;

var _ReactInjection = require('react/lib/ReactInjection');

var _ReactInjection2 = _interopRequireDefault(_ReactInjection);

var _ReactDefaultBatchingStrategy = require('react/lib/ReactDefaultBatchingStrategy');

var _ReactDefaultBatchingStrategy2 = _interopRequireDefault(_ReactDefaultBatchingStrategy);

var _ReactComponentEnvironment = require('react/lib/ReactComponentEnvironment');

var _ReactComponentEnvironment2 = _interopRequireDefault(_ReactComponentEnvironment);

var _reconcileTransaction = require('./reconcileTransaction');

var _reconcileTransaction2 = _interopRequireDefault(_reconcileTransaction);

var _ReactKonsulComponent = require('./ReactKonsulComponent');

var _ReactKonsulComponent2 = _interopRequireDefault(_ReactKonsulComponent);

var _ReactKonsulTextComponent = require('./ReactKonsulTextComponent');

var _ReactKonsulTextComponent2 = _interopRequireDefault(_ReactKonsulTextComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function inject() {
  (_ReactInjection2.default.NativeComponent || _ReactInjection2.default.HostComponent).injectGenericComponentClass(_ReactKonsulComponent2.default);
  (_ReactInjection2.default.NativeComponent || _ReactInjection2.default.HostComponent).injectTextComponentClass(_ReactKonsulTextComponent2.default);

  _ReactInjection2.default.Updates.injectReconcileTransaction(_reconcileTransaction2.default);

  _ReactInjection2.default.Updates.injectBatchingStrategy(_ReactDefaultBatchingStrategy2.default);

  _ReactComponentEnvironment2.default.processChildrenUpdates = function (element, data) {
    var update = data[0];

    if (update && update.type === 'INSERT_MARKUP') {
      update.content.setOrder(update.toIndex, true);
    }
  };
  _ReactComponentEnvironment2.default.replaceNodeWithMarkupByID = function () {};
  _ReactComponentEnvironment2.default.replaceNodeWithMarkup = function () {};
}


//////////////////
// WEBPACK FOOTER
// ../lib-react/lib/injection.js
// module id = 681
// module chunks = 0